import React from 'react'
import { Dashboard } from "./pages/Dashboard"
import GreenHouseApp from "./core/GreenHouseApp"
import AppContext from "./core/appContext"
import {
    BrowserRouter as Router,
    Switch,
    Route,
} from "react-router-dom";

import './styles/common.sass'

class App extends React.Component {
  constructor(props) {
      super(props);
      this.state = {
          greenHouseApp: new GreenHouseApp()
      }
  }

  render() {
      return (
          <Router>
              <AppContext.Provider value={this.state.greenHouseApp}>
                  <Switch>
                      <Route exact path="/app.html/:reff">
                          <Dashboard/>
                      </Route>
                      <Route exact path="/:reff">
                          <Dashboard/>
                      </Route>
                      <Route exact path="/">
                          <Dashboard/>
                      </Route>
                  </Switch>
              </AppContext.Provider>
          </Router>
      );
  }
}

export default App;
